import Vue from 'vue'

export default {
  setLayout: (state, payload ) => {
    state.layout = payload
  },
  setDashboardTitle: (state, title ) => {
    state.dashboardTitle = title
  },
  SET_MENU_DATA: (state, data) => {
    state.menuData = data;
  },
  SET_ACTION_TYPE: (state, data) => {
    state.actionType = data;
  },
  SET_OFFICE_ID: (state, data) => {
    state.officeId = data;
  },

  SET_H_TYPE: (state, data) => {
    state.hType = data;
  },

  SET_CURRENCY: (state, data) => {
    state.currency = data;
  }

}


// WEBPACK FOOTER //
// ./src/store/mutations.js